import { render, staticRenderFns } from "./visNumberGrow.vue?vue&type=template&id=b3061646"
import script from "./visNumberGrow.vue?vue&type=script&lang=js"
export * from "./visNumberGrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports